/**
 * T069: useDeletePrompt Hook
 * Mutation hook for deleting prompts with confirmation
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { deletePrompt } from '@/services/prompts'
import { queryKeys } from '@/lib/query-keys'

export function useDeletePrompt() {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  return useMutation({
    mutationFn: (id: string) => deletePrompt(id),
    onSuccess: (_, id) => {
      // Remove from cache
      queryClient.removeQueries({ queryKey: queryKeys.prompts.detail(id) })
      // Invalidate list
      queryClient.invalidateQueries({ queryKey: queryKeys.prompts.all })
      // Navigate to list
      navigate({ to: '/prompts' })
    },
  })
}
